import React from "react";
import PropTypes from "prop-types";

import Field from "./Field";

const QuickSearch = function (
    {
        action,
        show_quick_search = true,
        quick_search_placeholder = ''
    }
) {
    return (
        <form onSubmit={event => event.preventDefault()} className="form-inline">
            <Field
                show_quick_search={show_quick_search}
                quick_search_placeholder={quick_search_placeholder}
            />
            <button type="submit" className="button" onClick={event => {
                event.preventDefault();
                action();
            }}>
                <i className='fas fa-search'/>
                <span>Search</span>
            </button>
        </form>
    );
}

QuickSearch.propTypes = {
    show_quick_search: PropTypes.bool,
    quick_search_placeholder: PropTypes.string,
    action: PropTypes.func.isRequired
};

export default QuickSearch;
